import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import history from "../../route/history";
import moment from 'moment'
import { memberAppActions } from '../../store/actions/main/memberApp.actions';


const PushInfo = (props) => {
  	const [state, setState] = useState({})

  	useEffect(() => {
    	props.load();
	}, [])

	const prePage = (e) => {
		e.preventDefault();
		history.goBack();
	}


  return (
    <React.Fragment>
      {/* contents */}
      <div id="contents">	
        <div className="content-header type2">
          <a href="#" className="page-prev" onClick={prePage}>뒤로이동</a>
          <h2>알람함</h2>
          <div className="breadcrumb">
            <span>Home</span><em>알람함</em>
          </div>
        </div>
        <div className="alarm-wrap">
          <p className="txt">※ 최근 3개월 이내 알림 내역만 확인하실 수 있습니다.</p>
          <ul className="alarm-list">
	        {props.data?.length > 0 ? (
	          props.data?.map((pushObj, index) => (
            <li key={index} className="unconfirmed">
              <a href="#">
                <dl>
                  <dt>{pushObj.title}</dt>
                  <dd>
                    {pushObj.sendDt === null || moment(pushObj?.sendDt, 'YYYYMMDD').format('YYYY.MM.DD') === 'Invalid date'
                      ? '-'
                      : moment(pushObj?.sendDt, 'YYYYMMDD').format('YYYY.MM.DD')}
                  </dd>
                </dl>
              </a>
            </li>
            ))
            ) : (
            <li className="nodata">
              알림 내역이 없습니다.
            </li>
        	)}
          </ul>
        </div>
      </div>
      {/* //contents */}
    </React.Fragment>
  )
  
}

const mapStateToProps = (state) => {
	return {
		data : state.setting?.settingInfo?.list
	}
  }

const actionCreators = {
	load: memberAppActions.load
  }

export default connect(mapStateToProps, actionCreators)(PushInfo)
